'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _underscore = require('underscore');

var _ConversationalMessageModel = require('conversations-schema/models/ConversationalMessageModel');

var _clientSelectors = require('conversations-core/selectors/clientSelectors');

var _widgetDataSelectors = require('conversations-core/selectors/widgetDataSelectors');

var _pubNubMessageSelectors = require('conversations-core/selectors/pubNubMessageSelectors');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _OutgoingMessageActions = require('conversations-core/actions/OutgoingMessageActions');

var _outgoingMessagesSelectors = require('conversations-core/selectors/outgoingMessagesSelectors');

var _OfflineModeActions = require('conversations-visitor-ui/actions/OfflineModeActions');

var _offlineModeSelectors = require('conversations-visitor-ui/selectors/offlineModeSelectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (store) {
  var stageAwayMessageOnce = (0, _underscore.once)(function () {
    store.dispatch((0, _OfflineModeActions.stageAwayMessage)());
  });

  var setStagedMessageStatusesToPublishedOnce = (0, _underscore.once)(function () {
    store.dispatch((0, _OfflineModeActions.setStagedMessageStatusesToPublished)());
  });

  var isMessageFromThisClient = (0, _pipe2.default)((0, _getIn2.default)(['payload', 'message']), function (message) {
    return (0, _ConversationalMessageModel.getFrom)(message) === (0, _pubNubMessageSelectors.getClientRole)(store.getState());
  });

  var sendAllOutgoingMessages = function sendAllOutgoingMessages() {
    var outgoingMessages = (0, _outgoingMessagesSelectors.getOutgoingMessageQueue)(store.getState());
    outgoingMessages.filterNot(function (outgoingMessage) {
      return (0, _ConversationalMessageModel.isInitialMessage)(outgoingMessage.message);
    }).forEach(function (_ref) {
      var channel = _ref.channel,
          message = _ref.message;
      return store.dispatch((0, _OfflineModeActions.sendOfflineMessage)({ channel: channel, message: message }));
    });

    store.dispatch((0, _OutgoingMessageActions.clearOutgoingMessages)());
  };

  return function (next) {
    return function (action) {
      var nextAction = next(action);

      var isAgentReady = (0, _clientSelectors.getIsAgentReady)(store.getState());
      var shouldSendOfflineMessage = (0, _offlineModeSelectors.getShouldSendOfflineMessage)(store.getState());
      var hasVisitorEmail = (0, _widgetDataSelectors.getHasVisitorEmail)(store.getState());

      switch (action.type) {
        case _ActionTypes2.default.GET_CHAT_CONFIG_SUCCEEDED:
          if (!isAgentReady) {
            stageAwayMessageOnce();
            if (hasVisitorEmail) sendAllOutgoingMessages();
          }
          break;

        case _ActionTypes2.default.SEND_VISITOR_EMAIL_ADDRESS_SUCCEEDED:
          if (shouldSendOfflineMessage) sendAllOutgoingMessages();
          break;

        case _ActionTypes2.default.SEND_OFFLINE_MESSAGE_SUCCEEDED:
          setStagedMessageStatusesToPublishedOnce();
          break;

        case _ActionTypes2.default.ENQUEUE_OUTGOING_MESSAGE:
          if (shouldSendOfflineMessage && isMessageFromThisClient(action) && hasVisitorEmail) {
            var _action$payload = action.payload,
                channel = _action$payload.channel,
                message = _action$payload.message;


            store.dispatch((0, _OfflineModeActions.sendOfflineMessage)({ channel: channel, message: message }));
            store.dispatch((0, _OutgoingMessageActions.shiftOutgoingMessages)());
          }
          break;

        default:
          break;
      }

      return nextAction;
    };
  };
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/middleware/OfflineModeMiddleware.js
// module id = 416
// module chunks = 0 1